import type { BaseRecord } from '../../../domain';

export class AllCommentsRecords {
  public get records(): BaseRecord[] {
    return this._records.filter(record => record.commentsCount > 0);
  }

  constructor(private _records: BaseRecord[]) {}
}
